<box class="fpx-field-content">
    <box class="video-start" (click)="startVideoCapture()" >
        <ng-container [ngTemplateOutlet]="ngTemplateName ? getTemplate(ngTemplateName) : defaultTemplate" [ngTemplateOutletContext]="{ $implicit: label }" >
        </ng-container>
    </box>
</box>

<ng-template #defaultTemplate let-selectableData>{{selectableData}}</ng-template>